import { render, staticRenderFns } from "./weChatCustomer.vue?vue&type=template&id=49547ad4&scoped=true&"
import script from "./weChatCustomer.vue?vue&type=script&lang=js&"
export * from "./weChatCustomer.vue?vue&type=script&lang=js&"
import style0 from "./weChatCustomer.vue?vue&type=style&index=0&id=49547ad4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49547ad4",
  null
  
)

export default component.exports